import { toast } from 'react-toastify'
import get from 'lodash.get'
import cookie from 'react-cookies'
import store from '../store'
import { TRANSLATIONS_TEXTS_PER_CLIENT, TRANSLATIONS_TEXTS } from './constants'
import { setIsPopoverChatOpen } from '../store/general/actions'

export const callToaster = (type, message, customStyles = {}) => {
  toast(message, {
    type,
    autoClose: 3000,
    ...customStyles,
  })
}

export const getErrorMessage = error => {
  const errorMessage = get(error, 'response.data.message', null)
  return errorMessage
}

export const getLastPartOfUrl = () => {
  // Get the current URL
  var currentUrl = window.location.href

  // Remove the protocol and domain
  var pathWithoutDomain = currentUrl.replace(/^https?:\/\/[^\/]+/, '')

  // Remove any query parameters
  var pathWithoutQuery = pathWithoutDomain.split('?')[0]

  // Split the path by slashes and filter out any empty parts
  var pathParts = pathWithoutQuery.split('/').filter(function (part) {
    return part !== ''
  })

  // Get the last part of the path
  var lastPart = pathParts[pathParts.length - 1]

  return lastPart
}

export const getMayaCookieNameChatSlug = params => {
  let language = params.language
  let organizationSlug = params.organizationSlug
  let chatMode = params.chatMode

  let cookieNameChatSlug = `maya_chat_slug_${process.env.REACT_APP_API_ENV}_${language}_${organizationSlug}`

  if (chatMode === 'b2b') {
    cookieNameChatSlug += `_${getLastPartOfUrl()}`
  }

  return cookieNameChatSlug
}

export const getMayaCookieNameChatToken = params => {
  let language = params.language
  let organizationSlug = params.organizationSlug
  let chatMode = params.chatMode

  let cookieNameChatToken = `maya_chat_token_${process.env.REACT_APP_API_ENV}_${language}_${organizationSlug}`

  if (chatMode === 'b2b') {
    cookieNameChatToken += `_${getLastPartOfUrl()}`
  }

  return cookieNameChatToken
}

export const saveChatTokenAndSlugToCookie = ({
  slug,
  token,
  cookieNameChatSlug,
  cookieNameChatToken,
}) => {
  const readOnlyMode = store.getState().maya.readOnlyMode

  // DON'T SAVE TOKEN AND SLUG IN COOKIES IF READ ONLY MODE IS ENABLED
  if (readOnlyMode) return

  // SET SLUG AND TOKEN IN COOKIES
  // COOKIE LIFE IS 24HRS
  cookie.save(cookieNameChatSlug, slug, {
    path: '/',
    maxAge: 86400,
    domain: window.location.hostname,
  })
  cookie.save(cookieNameChatToken, token, {
    path: '/',
    maxAge: 86400,
    domain: window.location.hostname,
  })
}

export const handleIncompleteMarkdownLinks = text => {
  // Handle incomplete markdown links: remove `[text](` and keep only "text"
  text = text.replace(/\[([^\]]+)\]\([^\)]+$/, '$1')

  // Use a more robust regex to avoid capturing URLs that are part of complete markdown links
  const markdownLinkPattern = /\[([^\]]+)\]\(([^)]+)\)/g
  const standaloneUrlPattern = /(?<!\]\([^)]*)\bhttps?:\/\/[^\s)]+/gi

  // First, temporarily replace complete markdown links with placeholders
  const links = []
  text = text.replace(markdownLinkPattern, match => {
    links.push(match)
    return `__MARKDOWN_LINK_${links.length - 1}__`
  })

  // Process standalone URLs
  text = text.replace(standaloneUrlPattern, match => {
    try {
      const url = new URL(match)
      return url.origin + url.pathname // Remove query params for standalone URLs
    } catch {
      return match // Return original if it's not a valid URL
    }
  })

  // Restore complete markdown links
  links.forEach((link, i) => {
    text = text.replace(`__MARKDOWN_LINK_${i}__`, link)
  })

  return text
}

export const getTranslations = key => {
  const organizationSlug = store.getState().general.organizationSlug
  const language = store.getState().general.language

  // FIRST TRY TO GET THE TRANSLATION FROM THE ORGANIZATION SPECIFIC TRANSLATIONS
  let translation = get(
    TRANSLATIONS_TEXTS_PER_CLIENT,
    `${organizationSlug}.${key}.${language}`
  )
  if (translation) return translation

  // IF NOT FOUND, GET THE TRANSLATION FROM THE DEFAULT TRANSLATIONS
  return get(TRANSLATIONS_TEXTS, `${key}.${language}`, null)
}

// FUNCTION OUR CLIENTS CAN USE TO OPEN THE MAYA POPOVER CHAT
export const openMayaPopoverChat = (state = true) => {
  store.dispatch(setIsPopoverChatOpen(state))
}

export const setMayaDailyMessagesCount = () => {
  const currentDate = new Date()
  const currentDateString = currentDate.toISOString().split('T')[0]

  if (
    localStorage.getItem('maya_daily_messages_date') &&
    localStorage.getItem('maya_daily_messages_count')
  ) {
    const lastDate = localStorage.getItem('maya_daily_messages_date')
    if (lastDate === currentDateString) {
      return true
    }
  }

  localStorage.setItem('maya_daily_messages_date', currentDateString)
  localStorage.setItem('maya_daily_messages_count', 0)
}

export const incMayaDailyMessagesCount = () => {
  if (
    !localStorage.getItem('maya_daily_messages_date') ||
    !localStorage.getItem('maya_daily_messages_count')
  ) {
    setMayaDailyMessagesCount()
  }

  const currentCount =
    Number(localStorage.getItem('maya_daily_messages_count')) || 0
  localStorage.setItem('maya_daily_messages_count', currentCount + 1)

  return currentCount + 1
}
